import { defineMessages } from 'react-intl';

export const genericMessages = defineMessages({
	cancel: {
		id: 'generic.cancel',
		defaultMessage: 'Cancel',
		description: 'Generic "Cancel" text',
	},
	send: {
		id: 'generic.send',
		defaultMessage: 'Send',
		description: 'Generic "Send" text',
	},
	invalid_text: {
		id: 'generic.invalid_text',
		defaultMessage: 'Invalid text',
		description: 'Generic "Invalid text" text used as fallback when necessary',
	},
	loading: {
		id: 'generic.loading',
		defaultMessage: 'Loading',
		description: 'Generic "Loading" text',
	},
	sending: {
		id: 'generic.sending',
		defaultMessage: 'Sending...',
		description: 'Generic "Sending" text',
	},
	unread: {
		id: 'generic.unread',
		defaultMessage: 'Unread',
		description: 'Generic "Unread" text',
	},
	go_back: {
		id: 'generic.go_back',
		defaultMessage: 'Go back',
		description: '"Go back" text',
	},
	go_back_to: {
		id: 'generic.go_back_to',
		defaultMessage: 'Go back to {page}',
		description: '"Go back to..." text',
	},
	message: {
		id: 'generic.message',
		defaultMessage: '{count, plural, one {Message} other {Messages}}',
		description: '"Message" text',
	},
	orientation_alert: {
		id: 'generic.orientation_alert',
		defaultMessage:
			'Landscape orientation is not supported. Please rotate your device',
		description: 'Orientation alert message',
	},
	empty: {
		id: 'generic.empty',
		defaultMessage: 'Empty',
		description: 'Placeholder for "empty" values',
	},
	version: {
		id: 'generic.version',
		defaultMessage: 'Version',
		description: 'Version modal title',
	},
	remember_data: {
		id: 'generic.remember_data',
		defaultMessage: 'Remember me',
		description: '"Remember me" text',
	},
	selected: {
		id: 'generic.selected',
		defaultMessage: 'Selected',
		description: 'Generic "Selected" text',
	},
	yes: {
		id: 'generic.yes',
		defaultMessage: 'Yes',
		description: 'Generic "Yes" text',
	},
	no: {
		id: 'generic.no',
		defaultMessage: 'No',
		description: 'Generic "No" text',
	},
});
